<template>
  <div>
    <div id="account-setup" class="pt-2">
      <h3 class="mb-2 pb-2">Set up your XMission account</h3>
      <form-validator ref="form" v-model="customerFormValid">
        <div class="row">
          <div class="col-md-8">
              <div class="row mb-3">
                <div class="col-md-6">
                  <xm-input class="signup-input" name="fname" label="First name" v-model="fname" ref="fname" required></xm-input>
                </div>
                <div class="col-md-6">
                  <xm-input name="lname" label="Last name" v-model="lname" ref="lname" required class="signup-input"></xm-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <xm-input name="email" label="Email" type="email" v-model="email" :pattern="regex.email" error="Please enter a valid email address" ref="email" required class="signup-input"></xm-input>
                </div>
                <div class="col-md-4">
                  <xm-input name="phone" label="Phone number" type="tel" error="Please enter a valid phone number" v-model="phone" v-mask="'(###) ###-####'" :pattern="regex.phone" ref="phone" required class="signup-input"></xm-input>
                </div>
                <div class="col-md-4">
                  <label class="col-form-label">
                    Date of birth
                    <span class="btn-primary qtip" data-content="For more secure account verification you can enter a 'security date' instead.">?</span>
                  </label>
                  <xm-input class="signup-input" name="dob" v-mask="'##/##/####'" :pattern="dobPattern" placeholder="MM/DD/YYYY" error="Please enter a valid date of birth" v-model="dob" ref="dob" required></xm-input>
                </div>
              </div>
          </div>
        </div>
      </form-validator>
    </div>
    <transition v-on:enter="scrolldown('account-credentials')">
      <div id="account-credentials" v-show="customerFormValid">
        <h4 class="mt-3">XMission account credentials</h4>
        <user-form v-model="user_form" @form-valid="userFormValid = true" @form-invalid="userFormValid = false"/>
      </div>
    </transition>
  </div>
</template>

<script>
import FormValidator from '../FormValidator.vue'
import { BFormCheckbox } from 'bootstrap-vue'
import usernameSuggest from './UsernameSuggest.vue'
import addressForm from './AddressForm.vue'
import helpers from '../../lib/helpers'
import UserForm from './UserForm.vue'
import reg from '../../lib/regex'
import XmInput from '../XmInput.vue'


export default {
  name: "CustomerSignupForm",
  emits: ['form-state', 'form-valid', 'form-invalid', 'input'],
  components:{
    XmInput,
    usernameSuggest,
    FormValidator,
    addressForm,
    BFormCheckbox,
    UserForm
  },
  props:{
    value: {
      required: false,
      default: ()=>{return {}}
    },
  },
  data(){
    return {
      scrolldown: helpers.scrolldown,
      customerFormValid: false,
      userFormValid: false,
      regex: reg,
      fname: '',
      mnami: '',
      lname: '',
      email: '',
      phone:'',
      dob: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      zip_code: '',
      nameRegex: /^[a-zA-Z]+$/,
      user_form: {uid: '', password: ''}
    }
  },
  computed:{
    formValid() {
      return this.customerFormValid && this.userFormValid
    },
    formValues(){
      return {
        fname: this.fname,
        mnami: this.mnami,
        lname: this.lname,
        email: this.email,
        uid: this.user_form.uid,
        phone: this.phone,
        dob: this.dob,
        password: this.user_form.password,
      }
    },
  },
  methods : {
    dobPattern(dob) {
      const date = new Date(dob);
      if (isNaN(date.getTime())) {
        return false;
      }
      let mdy = dob.split('/');
      if (mdy.length !== 3) {
        return false;
      }
      if (mdy[2].length !== 4) {
        return false;
      }
      if (Number(mdy[2]) < 1900) {
        return false;
      }
      return date < new Date();
    }
  },
  watch:{
    formValues:{
      handler(newv){
        this.$emit('input', newv)
      },
      deep: true
    },
    formValid(newv){
      this.$emit('form-state', newv)
      this.$emit(newv?'form-valid':'form-invalid')
    },
  },
}
</script>

<style scoped>
.disabled-address-input{
  opacity: 0.25;
}

/** question mark tooltip - touch friendly **/
.qtip {
  position:relative;
  padding:1px;
  border-radius:100% !important;
  display:inline-block;
  height:16px;
  width:16px;
  font-size:12px;
  text-align:center;
}

.qtip:hover {cursor:help}

.qtip:hover:after, .qtip:focus:after {
  content: attr(data-content);
  position:absolute;
  background:#ffffee;
  padding:4px 6px;
  border:1px solid #ccc;
  bottom:20px;
  left:-25px;
  font-size:12px;
  color:#555;
  min-width:100px;
  width:10vw;
  max-width:300px;
  z-index:9001;
  text-align:left;
  line-height:14px;
  border-radius:3px;
  box-shadow:1px 1px 10px rgba(0,0,0,0.15);
}
</style>



// WEBPACK FOOTER //
// CustomerSignupForm.vue?5f94b7f0